export default {
  SOLICITACAO_EDITADA: 0,
  PADRAO: 1,
  NOVA_OCORRENCIA: 2,
  LEMBRETE_ORCAMENTO_PARCEIRO: 3,
  SOLICITACAO_FINANCIAMENTO: 4
}
